import React, { useState, useCallback, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSnackbar } from 'notistack';

import { PestsToolbar, PestsTable } from './components';
import api from 'services/api';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

const CustomerList = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [users, setCustomers] = useState([]);

  const fetchWeeds = useCallback(async () => {
    try {
      const response = await api.get('pests')

      setCustomers(response.data);
    } catch (err) {
      enqueueSnackbar('Não foi possível carregar os dados. Verifique sua conexão com a internet!', {
        variant: 'error',
      });
    }
  }, [enqueueSnackbar, setCustomers]);

  useEffect(() => {
    fetchWeeds();
  }, [fetchWeeds]);

  return (
    <div className={classes.root}>
      <PestsToolbar fetchList={fetchWeeds} />
      <div className={classes.content}>
        <PestsTable users={users} onFetch={fetchWeeds} />
      </div>
    </div>
  );
};

export default CustomerList;
